"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingMessage = void 0;
const constants_1 = require("../../pro-api/constants");
var LoggingMessage;
(function (LoggingMessage) {
    LoggingMessage["EmptySourceCode"] = "Empty source code. Obfuscation canceled...";
    LoggingMessage["ObfuscationCompleted"] = "Obfuscation completed. Total time: %s sec.";
    LoggingMessage["ObfuscationStarted"] = "Obfuscation started...";
    LoggingMessage["RandomGeneratorSeed"] = "Random generator seed: %s...";
    LoggingMessage["CodeTransformationStage"] = "Code transformation stage: %s...";
    LoggingMessage["NodeTransformationStage"] = "AST transformation stage: %s...";
    LoggingMessage["Version"] = "Version: %s";
    LoggingMessage["JavaScriptObfuscatorProAdFirstPart"] = "\uD83D\uDEE1\uFE0F JavaScript Obfuscator Pro is now available \u2014 with powerful Virtual Machine-based obfuscation\n(bytecode virtualization, anti-decompilation, unique opcode and VM structure each compilation, and more).";
    LoggingMessage["JavaScriptObfuscatorProAdSecondPart"] = "\uD83D\uDC49\uFE0F Get your API key at https://obfuscator.io and start using Virtual Machine obfuscation with javascript-obfuscator package.";
})(LoggingMessage || (exports.LoggingMessage = LoggingMessage = {}));
